export const CURRENCY = 'USD';
export const TTL_SECONDS = 60 * 5;
export const DEAL_ID_EXPIRY = 1000 * 60 * 15;
export const UNIQUE_DEAL_ID_EXPIRY = 1000 * 60 * 60;
export const SESSION_ID_KEY = 'vidSid';
export const OPT_CACHE_KEY = 'vdzwopt';
export const OPT_TIME_KEY = 'vdzHum';
